import { motion } from 'framer-motion';
import Logo from '../components/Logo';

function LoginPage() {
  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = `${window.location.origin}/dashboard`;
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-slate-50 flex flex-col">
      <div className="flex-1 flex items-center justify-center p-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="max-w-md w-full"
        >
          <div className="text-center mb-8">
            <div className="inline-flex items-center justify-center mb-6\">
              <Logo size="xl" />
            </div>
            <h1 className="text-4xl md:text-5xl font-heading font-bold text-slate-900 tracking-tight mb-3\">
              Expense Flow for Small Biz
            </h1>
            <p className="text-base text-slate-600 leading-relaxed">
              Transform your invoice chaos into organized data.
              <br />Automatically extract, review, and save to Google Drive.
            </p>
          </div>

          <div className="bg-white border border-slate-100 rounded-2xl shadow-sm p-8">
            <div className="space-y-4 mb-6">
              <div className="flex items-start space-x-3">
                <div className="w-6 h-6 rounded-full bg-indigo-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <span className="text-xs font-semibold text-indigo-700">1</span>
                </div>
                <div>
                  <p className="text-sm font-medium text-slate-900">Upload invoices</p>
                  <p className="text-xs text-slate-500 mt-0.5">Drop PDFs or screenshots</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <div className="w-6 h-6 rounded-full bg-indigo-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <span className="text-xs font-semibold text-indigo-700">2</span>
                </div>
                <div>
                  <p className="text-sm font-medium text-slate-900">AI extracts data</p>
                  <p className="text-xs text-slate-500 mt-0.5">Review and edit if needed</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <div className="w-6 h-6 rounded-full bg-emerald-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <span className="text-xs font-semibold text-emerald-700">3</span>
                </div>
                <div>
                  <p className="text-sm font-medium text-slate-900">Export to Drive</p>
                  <p className="text-xs text-slate-500 mt-0.5">Secure Excel storage</p>
                </div>
              </div>
            </div>

            <button
              onClick={handleLogin}
              data-testid="login-button"
              className="w-full bg-indigo-700 text-white hover:bg-indigo-800 shadow-sm hover:shadow-md transition-all duration-200 font-medium px-6 py-3 rounded-lg flex items-center justify-center space-x-2"
            >
              <span>Continue with Google</span>
            </button>

            <p className="text-xs text-center text-slate-400 mt-4">
              Secure authentication via Google OAuth
            </p>
          </div>
        </motion.div>
      </div>
    </div>
  );
}

export default LoginPage;